export default function StructureName({selectedRS, cs, strItem, textColor}) {

    if(cs?.typeName === 'Bridge') {
        return (
            <div style={{color: cs.cross_section === selectedRS ? 'red' : textColor}}>
                {cs?.typeName}<br/>
                RS {cs.cross_section}
            </div>
        )
    }

    return (
        <div style={{color: cs.cross_section === selectedRS ? 'red' : textColor}}>
            {cs?.typeName} #{strItem?.culvert_number}<br/>
            RS {cs.cross_section}
            {
                strItem?.barrel_count > 1 && (
                    <>
                        <br />
                        Barrel #{strItem?.barrel_number}
                    </>
                )
            }
        </div>
    )
}